import Ginkolet from "../../resources/images/Ginkolet.svg";
import Siplin from "../../resources/images/Siplin.svg";
import Biotil from "../../resources/images/Biotil.svg";
import Biosina from "../../resources/images/Biosina.svg";
import Biovina from "../../resources/images/Biovina.svg";
import Bioga from "../../resources/images/Bioga.svg";
import Panexgine from "../../resources/images/Panexgine.svg";
import Ginkolet2 from "../../resources/images/Ginkolet.jpg";
import Siplin2 from "../../resources/images/Siplin.jpg";
import Biotil2 from "../../resources/images/Biotil.jpg";
import Biosina2 from "../../resources/images/Biosina.jpg";
import Bioga2 from "../../resources/images/Bioga.jpg";
import Panexgine2 from "../../resources/images/Panexgine.jpg";

const productsData = [
  {
    name: "Ginkolet",
    details: "Cerebral And Peripheral Vasotherapeutic",
    img: Ginkolet,
    img2: Ginkolet2,
    genericName: "Ginkgo Biloba",
    id: 1,
    indication1: "Cerebral insufficiency",
    banglaIndication1: "সেরিব্রাল রক্ত সরবরাহ স্বল্পতা",
    indication2:
      "Demential syndromes: memory deficit, poor concentration, depression, dizziness and headache",
    banglaIndication2:
      "স্মৃতিশক্তি সিন্ড্রোমস: স্মৃতির ঘাটতি, মনোযোগের অভাব, হতাশা, বিষণ্ণতা, মাথার মধ্যে ঘোর ঘোর অনুভব করা এবং মাথা ব্যথা",
    indication3: "Reduces symptoms of Psychiatric Disorders and Dementia",
    banglaIndication3:
      "সাইকিয়াট্রিক ডিসঅর্ডার এবং ডিমেনটিয়ার লক্ষণ হ্রাস করে",
    indication4: "Tinnitus & Vertigo",
    banglaIndication4: "মাথা ঘোরা এবং কানে ভোঁভোঁ শব্দ করা",
    indication5: "Peripheral vascular diseases",
    banglaIndication5: "পেরিফেরাল ভাস্কুলার ডিজিজ(পিভিডি)",
    indication6: "Sexual dysfunction, Combination with SSRI",
    banglaIndication6: "এসএসআরআইের সাথে কম্বিনেশান",
    indication7: "Acute & chronic cochlear deafness",
    banglaIndication7: "তীব্র ও দীর্ঘস্থায়ী শ্রবণ শক্তির দুর্বলতা",
    indication8: "Improves Blood Circulation of Heart",
    banglaIndication8: "হ্রিতপিন্ডের রক্ত সঞ্চালন বৃদ্ধি করে",
    doses:
      "Ginkolet 120 mg 1 or 2 capsule 2 to 3 times daily or as advised by the physician.",
    banglaDoses:
      "Ginkolet 120 মিলিগ্রাম 1টি বা 2টি ক্যাপসুল দিনে 2 থেকে 3 বার বা চিকিৎসকের পরামর্শ অনুসারে।",
    preparation: "30's container pack",
    banglaPreparation: "30টি ক্যাপসুলের প্যাক",
    largeDetail:
      "Ginkgo Biloba contains powerful Antioxidants. It helps fight Inflammation. Improves Circulation and Heart Health, Brain Function and Well-Being, Asthma and COPD symptoms. Reduces symptoms of Psychiatric Disorders and Dementia, Anxiety, PMS symptoms. Treat Depression, Headaches and Migraines, Sexual Dysfunction. Support Vision and Eye Health.",
    banglaLargeDetail:
      "জিঙ্কগো বিলোবাতে শক্তিশালী অ্যান্টিঅক্সিডেন্ট রয়েছে। এটি Inflammation কমাতে সহায়তা করে। Improves Blood Circulation(শুক্ষ রক্তনালিকা প্রসারিত করার মাদ্ধমে রক্ত চলাচল বৃদ্ধি করে)। হৃৎপিণ্ড সুস্থ করে। মস্তিস্কের কার্যকারিতা বৃদ্ধি করে। Asthma এবং COPDর চিকিৎসায় বাবহৃত হয়। মানসিক রোগের লক্ষন সমূহ দূর করে এবং Dementia দূর করে, Anxiety(দুশ্চিন্তা) দুর করে, Premenstrual syndrome দুর করে। বিষণ্ণতা, Headaches and Migraines, Sexual Dysfunctionএর চিকিৎসায় ব্যবহৃত হয়। দৃষ্টিশক্তি এবং চোখের স্বাস্থ্য Improve করে।",
    keywords: "ginkgo biloba, ginkgo biloba in bd, ginkgo biloba in bangladesh, ginkgo biloba bd, ginkgo biloba bangladesh"
  },
  {
    name: "Panexgine",
    details:
      "Nervous weakness, Sexual weakness, Weakness of memory, Alcohol side effects, Virus infection",
    img: Panexgine,
    img2: Panexgine2,
    genericName: "Panax Gingseng",
    id: 2,
    indication1: "Potent Antioxidant that may reduce Inflammation",
    banglaIndication1:
      "পানাক্স জিনসেং Inflammation কমিয়ে দেয় এবং এটি খুব শক্তিশালী অ্যান্টিঅক্সিড্যান্ট",
    indication2: "Benefit Brain Function",
    banglaIndication2: "এটি ব্রেইন ফাংশন Improve করে",
    indication3: "Improve Erectile Dysfunction",
    banglaIndication3: "ইটি ইরেকটাইল ডিসফংশনের চিকিৎসায়ে অত্যন্ত কার্যকর",
    indication4: "Boosts the Immune System",
    banglaIndication4: "এটি ইমিউন সিস্টেমকে(রোগ প্রতিরোধ ক্ষমতা) বৃদ্ধি করে",
    indication5: "Have potential benefits against Cancer",
    banglaIndication5: "এটি ক্যান্সার প্রতিরাধ করতে সহায়তা করে",
    indication6: "Fight Tiredness and increase Energy Levels",
    banglaIndication6:
      "এটি ক্লান্তি দুর করে এবং Energy Level বাড়াতে সহায়তা করে",
    indication7: "Lower Blood Sugar",
    banglaIndication7: "ব্লাড সুগার হ্রাস করে",
    doses:
      "Panexgine 500 mg half capsule daily or as advised by the physician.",
    banglaDoses:
      "Panexgine 500 মিলিগ্রাম আধা ক্যাপসুল দৈনিক বা চিকিৎসকের পরামর্শ অনুসারে।",
    largeDetail:
      "Panax Gingseng has potent Antioxidant that reduce Inflammation. It benefit Brain Function. It improves Erectile Dysfunction. It boosts the Immune system. It has potential benefits against Cancer. It helps fight Tiredness and Increase Energy Levels. It can lower Blood Sugar. It helps treat and prevent Influenza.",
    banglaLargeDetail:
      "পানাক্স জিনসেং Inflammation কমিয়ে দেয়। এটি খুব শক্তিশালী অ্যান্টিঅক্সিড্যান্ট। এটি ব্রেইন ফাংশন Improve করে। এটি ইরেকটাইল ডিসফংশনের সমস্যা দূর করে। এটি ইমিউন সিস্টেমকে বাড়িয়ে তোলে। এটি ক্যান্সার প্রতিরাধ করতে সহায়তা করে। এটি ক্লান্তি দুর করে এবং Energy Level বাড়াতে সহায়তা করে। এটি ব্লাড সুগার হ্রাস করে। এটি Influenza চিকিৎসা এবং প্রতিরোধে সহায়তা করে।",
    preparation: "30's container pack",
    banglaPreparation: "30টি ক্যাপসুলের প্যাক",
    keywords: "ginseng, ginseng in bd, ginseng in bangladesh, ginseng bd, ginseng bangladesh, panax ginseng, panax ginseng in bd, panax ginseng in bangladesh, panax ginseng bd, panax ginseng bangladesh"
  },
  {
    name: "Siplin",
    details: "Protein, Vitamins And General Nutrients",
    img: Siplin,
    img2: Siplin2,
    genericName: "Spirulina",
    id: 3,
    indication1: "Anemia",
    banglaIndication1: "রক্তশুন্যতা",
    indication2: "Malnutrition",
    banglaIndication2: "অপুষ্টি",
    indication3: "Viral Hepatitis",
    banglaIndication3: "ভাইরাল হেপাটাইটিস",
    indication4: "Hyper Cholesterolemia",
    banglaIndication4: "কোলেস্টরলের আধিক্ষ",
    indication5: "Diabetes",
    banglaIndication5: "ডায়াবেটিস",
    indication6: "General Weakness",
    banglaIndication6: "সাধারণ দুর্বলতা",
    indication7: "Fibromyalgia",
    banglaIndication7: "ফাইব্রোমায়ালজিয়া",
    indication8: "Unexpected Aging",
    banglaIndication8: "অকাল বার্ধক্য",
    indication9: "Allergy",
    banglaIndication9: "অ্যালার্জি",
    indication10: "Harpes",
    banglaIndication10: "হার্পস",
    indication11:
      "Prevent Tobacco induced Oral Cancer and treat Precancerous Lesion",
    banglaIndication11:
      "তামাকের কারণে হওয়া মুখের ক্যানসার প্রতিরোধ করে এবং ক্যানসারের পূর্ব পরিস্থিতিতে হওয়া ক্ষতিগুলোর চিকিৎসায়ে অত্যন্ত কার্যকর",
    indication12: "Leukoplakia",
    banglaIndication12: "লিউকোপ্লাকিয়া",
    indication13: "Psoriasis",
    banglaIndication13: "সোরিয়াসিস",
    indication14: "Eczema",
    banglaIndication14: "একজিমা",
    doses:
      "Spirulina 450mg 2 or 3 capsule 2 to 4 times daily or as advised by the physician",
    banglaDoses:
      "Spirulina 450 মিলিগ্রাম 2টি বা 3টি ক্যাপসুল দিনে 2 থেকে 4 বার অথবা চিকিৎসকের পরামর্শ অনুযায়ী",
    largeDetail:
      "Spirulina contains high protein (55%-77%), Essential Fatty Acid, Vitamin B1, B2, B6, C, D, E, Nicotinamide and Folic Acid. It is also delicious source of Potassium and Several minerals such As Calcium, Copper, Iron, Magnesium, Phosphorus, Manganese, Sodium, Selenium and Zinc.",
    banglaLargeDetail:
      "স্পিরুলিনাতে উচ্চ পরিমানে প্রোটিন রয়েছে (55% -77%), এসেনশিয়াল ফ্যাটি অ্যাসিড, ভিটামিন বি 1, বি 2, বি 6, সি, ডি, ই, নিকোটিনামাইড এবং ফলিক এসিড. এটি পটাসিয়াম এবং ক্যালসিয়াম, তামা, আয়রন, ম্যাগনেসিয়াম, ফসফরাস, ম্যাঙ্গানিজ, সোডিয়াম, সেলেনিয়াম এবং জিঙ্ক এর উচ্চ মানের উৎস।",
    benefits: "Benefits of Spirulina:",
    preparation: "30's container pack",
    banglaPreparation: "30টি ক্যাপসুলের প্যাক",
    benefit1: "Protect Liver",
    banglaBenefit1: "লিভারকে সুরক্ষিত রাখে",
    benefit2: "Strong Blood Enhancer",
    banglaBenefit2: "উচ্চ ক্ষমতা সম্পন্ন রক্তবর্ধক",
    benefit3: "Develop Immune System",
    banglaBenefit3: "রোগ প্রতিরোধ ক্ষমতাকে ডেভেলপ করে",
    benefit4: "Lower Cholesterol",
    banglaBenefit4: "কোলেস্টেরল হ্রাস করে",
    benefit5: "Strengthening",
    banglaBenefit5: "বল ও পুষ্টিকারক",
    benefit6: "Nutritious",
    banglaBenefit6: "Nutritious",
    benefit7: "Lowering Blood Glucose and Antiviral",
    banglaBenefit7: "রক্তের গ্লূকোজ হ্রাস করে এবং অ্যান্টিভাইরাল",
    keywords: "spirulina, spirulina in bd, spirulina in bangladesh, spirulina bd, spirulina bangladesh"
  },
  {
    name: "Biotil",
    details: "The Millenium Brain Booster And Antioxidants",
    img: Biotil,
    img2: Biotil2,
    genericName: "Brahmi Rasayan",
    id: 4,
    indication1: "Contains powerful Antioxidants",
    banglaIndication1: "এটি একটি শক্তিশালী অ্যান্টিঅক্সিড্যান্ট",
    indication2: "Reduce Inflammation",
    banglaIndication2: "Inflammation কমিয়ে দেয়",
    indication3: "Boost Brain Function",
    banglaIndication3: "ব্রেইন ফাংশন Boost করে",
    indication4: "Help reduce ADHD symptoms",
    banglaIndication4: "ADHD এর লক্ষণ গুলোকে হ্রাস করতে সহায়তা করে",
    indication5: "Prevent Anxiety and Stress",
    banglaIndication5: "দুশ্চিন্তা এবং Stress প্রতিরোধ করে",
    indication6: "Help lower Blood Pressure levels",
    banglaIndication6: "রক্তচাপ Level কে কমাতে সহায়তা করে",
    indication7: "Have Anti-Cancer properties",
    banglaIndication7: "এটি ক্যান্সার প্রতিরোধে সহায়তা করে",
    doses:
      "Biotil 1 - 2 teaspoonful, 1 or 2 times a day or as advised by the physician.",
    banglaDoses:
      "Biotil 1 থেকে 2 চা চামচ, দিনে 1 থেকে 2 বার অথবা চিকিৎসকের পরামর্শ অনুসারে।",
    preparation: "450ml Bottle",
    banglaPreparation: "450 মিলিলিটারের বোতল",
    largeDetail:
      "Contains powerful Antioxidants. Reduce Inflammation. Boost Brain Function. Help reduce ADHD symptoms. Prevent Anxiety and Stress. Help lower Blood Pressure levels. Have Anti-Cancer properties",
    banglaLargeDetail:
      "Inflammation কমিয়ে দেয়। এটি একটি শক্তিশালী অ্যান্টিঅক্সিড্যান্ট। ব্রেইন ফাংশন Boost করে। ADHD এর লক্ষণ গুলোকে হ্রাস করতে সহায়তা করে। দুশ্চিন্তা এবং Stress প্রতিরোধ করে । রক্তচাপ Level কে কমাতে সহায়তা করে । এটি ক্যান্সার প্রতিরোধে সহায়তা করে।",
    keywords: "brahmi rasayan, brahmi rasayan in bd, brahmi rasayan in bangladesh, brahmi rasayan bd, brahmi rasayan bangladesh"
  },
  {
    name: "Biosina",
    details: "Liver Protective And Improve Digestive System",
    img: Biosina,
    img2: Biosina2,
    genericName: "Nabayas Louha",
    id: 5,
    indication1: "Iron deficiency Anemia",
    banglaIndication1: "Iron এর অভাবে হও রক্তশূন্যতা",
    indication2: "Jaundice",
    banglaIndication2: "জন্ডিস",
    indication3: "Spleen and Lever Disease",
    banglaIndication3: "প্লীহা এবং লিভারের রোগের চিকিৎসায়ে সহায়তা করে",
    indication4: "Anemia due to Malnutrition",
    banglaIndication4: "পুষ্টিহীনতার কারণে হওয়া রক্তশূন্যতা",
    indication5: "Hemmorhoids",
    banglaIndication5: "অর্শ্বরোগ",
    indication6: "Dermatitis",
    banglaIndication6: "চর্মরোগ",
    indication7: "Cardiac sedative",
    banglaIndication7: "হৃৎপিণ্ডের প্রশান্তিদায়ক",
    indication8: "Loss of appetite & debility",
    banglaIndication8: "ক্ষুধা এবং দুর্বলতা হ্রাস করে",
    doses: `Adult: 1 capsule should be taken daily before meal. 
    Children: Not recommended for children under 12 years of age.`,
    banglaDoses: `প্রাপ্তবয়স্ক: প্রতিদিন খাওয়ার আগে 1টি করে ক্যাপসুল। 
    শিশু: 12 বছরের কম বয়সীদের জন্য প্রস্তাবিত নয়`,
    preparation: "6 x 5's blister pack",
    banglaPreparation: "6 x 5টি ক্যাপসুলের ব্লিস্টার",
    largeDetail:
      "Iron deficiency Anemia. Jaundice. Spleen. Anemia due to Malnutrition. Hemmorhoids. Dermatitis. Cardiac Sedative. Loss of Appetite & Debility.",
    banglaLargeDetail:
      "Iron এর অভাবে হও রক্তশূন্যতা। জন্ডিস। প্লীহা। পুষ্টিহীনতার কারণে হওয়া রক্তশূন্যতা। অর্শ্বরোগ। চর্মরোগ। হৃৎপিণ্ডসংবন্ধীয় প্রশান্তিদায়ক। ক্ষুধা এবং দুর্বলতা হ্রাস করে।",
    keywords: "nabayas louha, nabayas louha in bd, nabayas louha in bangladesh, nabayas louha bd, nabayas louha bangladesh"
  },
  {
    name: "Biovina",
    details: "Strength, Nutritious, Heart, Digestive",
    img: Biovina,
    img2: Biovina,
    genericName: "Chandanasav",
    id: 6,
    indication1: "Spermetorrhoea Sedative",
    banglaIndication1: "স্পারমেটরিয়া সেডাটিভ",
    indication2: "Strength Nutritious",
    banglaIndication2: "বল পুষ্টিকারক",
    indication3: "Heart",
    banglaIndication3: "হৃৎপিণ্ডের শক্তিবর্ধক",
    indication4: "Digestive",
    banglaIndication4: "হজমিকারক",
    doses: "5 - 60ml daily or as advised by the physician.",
    banglaDoses: "5 থেকে 60 মিলিলিটার প্রতিদিন অথবা চিকিৎসকের পরামর্শ অনুসারে",
    largeDetail:
      "Spermetorrhoea Sedative. Strength Nutritious. Heart and digestive.",
    banglaLargeDetail:
      "স্পারমেটরিয়া সেডাটিভ। শক্তি পুষ্টিকারক। হৃৎপিণ্ড এবং হজমিকারক।",
    preparation: "450ml Bottle",
    banglaPreparation: "450 মিলিলিটারের বোতল",
    keywords: "chandanasav, chandanasav in bd, chandanasav in bangladesh, chandanasav bd, chandanasav bangladesh"
  },
  {
    name: "Bioga",
    details: "Sexual enhancer, Sustainability editor of orgasm",
    img: Bioga,
    img2: Bioga2,
    genericName: "Rati Bilas",
    id: 7,
    indication1: "Sexual enhancer",
    banglaIndication1: "যৌন বর্ধক",
    indication2: "Sustainability editor of Orgasm",
    banglaIndication2: "অর্গাজমের স্থায়িত্ব সম্পাদক",
    largeDetail: "Sexual enhancer, Sustainability editor of Orgasm.",
    banglaLargeDetail: "যৌন বর্ধক, অর্গাজমের স্থায়িত্ব সম্পাদক.",
    doses:
      "1 Capsule to be taken daily at bed time or as advised by the physician.",
    banglaDoses:
      "প্রতিদিন ঘুমাতে যাওয়ার আগে ১টি করে ক্যাপসুল বা চিকিৎসকের পরামর্শ অনুসারে।",
    preparation: "6 X 5'S Blister Pack",
    banglaPreparation: "6 x 5টি ক্যাপসুলের ব্লিস্টার",
    keywords: "rati bilas, rati bilas in bd, rati bilas in bangladesh, rati bilas bd, rati bilas bangladesh"
  },
];
export default productsData;
